<template>
  <br><br>
  <h1>{{terms_text}}</h1>
  <h5>Last updated: <span style="opacity: 0.6">December 2025</span> </h5>
  <div class="title">1. Service provider</div>
  <div class="description">These terms govern your use of the UPAYS service provided by:</div>
  <br>
  <textarea style="border: none;background-color: black;color: white" rows="6"  cols="60" disabled>

    ulip OÜ
    VAT ID: EE102153321
    Reg.no: 14627808
    Sepapaja tn 6, 15551 Tallinn, Harju maakond Estonia
  </textarea>
  <div class="title">2. Services description </div>
  <div class="description">
    Our service offers a solution that "covers" the implementations necessary to integrate payments via STRIPE into a web application<br>
    (implementation in FrontEnd & BackEnd components) plus an authentication system for those who have paid via UPAYS.<br>
    UPAYS generates a web link ( aka PAYLink ) [TEST/PRODUCTION], this can be tested with  the STRIPE test API.<br>The User must customize 2 parameters in PAYLink, then can use it by attaching it to a "payment button".<br>
    <b><i class="fa fa-shield" aria-hidden="true"></i>
      The PAYLink must be used first in the TEST mode then in PRODUCTION mode</b>
  </div>
  <div class="title">3. Payment</div>
  <div class="description"> To use the service we offer a lifetime fee of <span style="font-weight: bold">19$</span> (or credits - that means you choose the currency).<br>
    A trial period is also available : free use for 30 days<br>
    The fee payment is processed through STRIPE.( Third-party payments service providers )<br>
    All users' financial information is managed securely  and in accordance to security standards.<br>
    STRIPE protects users' personal data throughout the payment process.
  </div>
  <div class="title">4. Third-party payments providers</div>
  <div class="description">
    UPAYS currently uses Stripe, Inc., as third-party service providers for payment processing services<br>
    (e.g., card acceptance, merchant settlement, and related services). By through the Services,<br>
    you (a) agree to be bound by, in the case of Stripe, Stripe's Privacy Policy (currently accessible at
    <a style="font-size: 18px;color:crimson" href="https://stripe.com/us/privacy" target="_blank"> https://stripe.com/us/privacy)</a>
  </div>
  <div class="title">5. Sign-in</div>
  <div class="description">Payment or use of the free trial will generate a unique 64-digit key that must be used for authentication.[sign-in]</div>
  <div class="title">6. Service Availability</div>
  <div class="description"> While we strive for high availability, we do not guarantee uninterrupted service.<br>
    We may perform maintenance, updates, or experience technical issues that temporarily affect service availability.</div>
  <div class="title">7.Limitation of Liability</div>
  <div class="description"> Our liability is limited concerning STRIPE payments.<br>
    Please use the TEST PAYLink to check our service and <br> verify that payments are ok on the STRIPE Server [ in your account ].<br>
    We have a logging system for all error cases, please contact support in case of any problems.
  </div>
  <div class="title">8. Governing Law</div>
  <div class="description"> These terms are governed by Estonian law. Any disputes will be resolved in Estonian courts.</div>
  <div class="title">9. Changes to Terms</div>
  <div class="description">We may update these terms periodically. Continued use of the service constitutes acceptance of updated terms.</div>
  <br>
  <button class="close" @click="this.$router.go(-1)">Back</button>
  <br><br>
</template>
<script>
export default {
  name: 'Terms',
  data() {
    return {
      terms_text:''
    }
  },
  mounted() {
    this.terms_text = "Terms of Service"
    window.scroll(0,0)
  }
}
</script>
<style scoped>
@import "../assets/buttons.css";
 .description {
   font-size: 20px;
   font-family: "Apple Symbols",fantasy;
 }
 .title {
   font-weight: bold;
   color: crimson;
   margin-top: 10px;
   margin-bottom: 15px;
   font-size: 25px;
 }
 @media (max-width: 430px) {
   .title {
     font-size: 16px;
   }
   h3 {
     font-size: 13px;
   }
   .description {
     font-size: 14px;
   }
   textarea {
     width: 100%;
     font-size: 8px;
   }

 }
</style>